import { render, staticRenderFns } from "./PurchaseModal.vue?vue&type=template&id=241753e9&scoped=true&"
import script from "./PurchaseModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseModal.vue?vue&type=style&index=0&id=241753e9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241753e9",
  null
  
)

export default component.exports